/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_Ecommerce_Amazon_Tools_Work_0_BadgeInputs */

const en_svc_ecommerce_amazon_tools_work_0_badge = /** @type {(inputs: Svc_Ecommerce_Amazon_Tools_Work_0_BadgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`E-commerce automation`)
};

const ar_svc_ecommerce_amazon_tools_work_0_badge = /** @type {(inputs: Svc_Ecommerce_Amazon_Tools_Work_0_BadgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`أتمتة تجارة إلكترونية`)
};

const bn_svc_ecommerce_amazon_tools_work_0_badge = /** @type {(inputs: Svc_Ecommerce_Amazon_Tools_Work_0_BadgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ই-কমার্স অটোমেশন`)
};

const de_svc_ecommerce_amazon_tools_work_0_badge = /** @type {(inputs: Svc_Ecommerce_Amazon_Tools_Work_0_BadgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`E-Commerce-Automatisierung`)
};

const es_svc_ecommerce_amazon_tools_work_0_badge = /** @type {(inputs: Svc_Ecommerce_Amazon_Tools_Work_0_BadgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Automatización del comercio electrónico`)
};

const fr_svc_ecommerce_amazon_tools_work_0_badge = /** @type {(inputs: Svc_Ecommerce_Amazon_Tools_Work_0_BadgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Automatisation du commerce électronique`)
};

const pt_svc_ecommerce_amazon_tools_work_0_badge = /** @type {(inputs: Svc_Ecommerce_Amazon_Tools_Work_0_BadgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Automação de comércio eletrônico`)
};

const zh_svc_ecommerce_amazon_tools_work_0_badge = /** @type {(inputs: Svc_Ecommerce_Amazon_Tools_Work_0_BadgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`电子商务自动化`)
};

const tr_svc_ecommerce_amazon_tools_work_0_badge = /** @type {(inputs: Svc_Ecommerce_Amazon_Tools_Work_0_BadgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`E-ticaret otomasyonu`)
};

const ru_svc_ecommerce_amazon_tools_work_0_badge = /** @type {(inputs: Svc_Ecommerce_Amazon_Tools_Work_0_BadgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Автоматизация электронной коммерции`)
};

const pl_svc_ecommerce_amazon_tools_work_0_badge = /** @type {(inputs: Svc_Ecommerce_Amazon_Tools_Work_0_BadgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Automatyzacja handlu elektronicznego`)
};

/**
* | output |
* | --- |
* | "E-commerce automation" |
*
* @param {Svc_Ecommerce_Amazon_Tools_Work_0_BadgeInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
const svc_ecommerce_amazon_tools_work_0_badge = /** @type {((inputs?: Svc_Ecommerce_Amazon_Tools_Work_0_BadgeInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_Ecommerce_Amazon_Tools_Work_0_BadgeInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svc_ecommerce_amazon_tools_work_0_badge(inputs)
	if (locale === "bn") return bn_svc_ecommerce_amazon_tools_work_0_badge(inputs)
	if (locale === "de") return de_svc_ecommerce_amazon_tools_work_0_badge(inputs)
	if (locale === "es") return es_svc_ecommerce_amazon_tools_work_0_badge(inputs)
	if (locale === "fr") return fr_svc_ecommerce_amazon_tools_work_0_badge(inputs)
	if (locale === "pt") return pt_svc_ecommerce_amazon_tools_work_0_badge(inputs)
	if (locale === "zh") return zh_svc_ecommerce_amazon_tools_work_0_badge(inputs)
	if (locale === "tr") return tr_svc_ecommerce_amazon_tools_work_0_badge(inputs)
	if (locale === "ru") return ru_svc_ecommerce_amazon_tools_work_0_badge(inputs)
	if (locale === "pl") return pl_svc_ecommerce_amazon_tools_work_0_badge(inputs)
	return en_svc_ecommerce_amazon_tools_work_0_badge(inputs)
});
export { svc_ecommerce_amazon_tools_work_0_badge as "svc_ecommerce-amazon-tools_work_0_badge" }